export default __webpack_public_path__ + "static/media/40_aniversario.bf9e8321.png";